import { render, staticRenderFns } from "./MenuAdd.vue?vue&type=template&id=f4686592&scoped=true"
import script from "./MenuAdd.vue?vue&type=script&lang=ts"
export * from "./MenuAdd.vue?vue&type=script&lang=ts"
import style0 from "./MenuAdd.vue?vue&type=style&index=0&id=f4686592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4686592",
  null
  
)

export default component.exports